export const CHAIN_META = {
  1: { name: "Ethereum", symbol: "ETH" },
  56: { name: "BNB Chain", symbol: "BNB" },
  97: { name: "BNB Testnet", symbol: "tBNB" },
  137: { name: "Polygon", symbol: "POL" },
  42161: { name: "Arbitrum", symbol: "ETH" },
  10: { name: "Optimism", symbol: "ETH" },
};

export function chainNameById(chainId) {
  if (!chainId) return "Unknown";
  return CHAIN_META[chainId]?.name || `Chain ${chainId}`;
}

export function chainSymbolById(chainId) {
  if (!chainId) return "ETH";
  return CHAIN_META[chainId]?.symbol || "ETH";
}
